import React, { useEffect, useRef, useState } from 'react';
import cx from 'classnames';
import DoneIcon from '@mui/icons-material/Done';
import styles from '@/common/components/Stepper/styles.less';
import { useStepperContext } from '@/common/hooks/index';

const Stepper = () => {
  const { steps, currentStepInd } = useStepperContext();
  const [list, setList] = useState([]);

  useEffect(() => {
    setList(steps.map((name, ind) => ({ name, done: ind < currentStepInd })));
  }, [steps, currentStepInd]);

  return (
    <div className={styles.container}>
      {list.map(({ name, done }, ind) => (
        <React.Fragment key={ind}>
          {ind > 0 && <div className={styles.line} />}
          <div
            className={cx(
              styles.step,
              (currentStepInd === ind || done) && styles['step-active'],
              currentStepInd === ind && styles['step-current']
            )}
          >
            <div className={styles.stepCircle}>
              {done ? <DoneIcon /> : ind + 1}
            </div>
            <span className={styles.stepText}>{name}</span>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

export default Stepper;
